
import {
  CHANGE_USERNAME,
  TO_LIST,
  TO_MASONRY,
  CHANGE_PAGESIZE,
  CHANGE_PAGE,
  CHANGE_MORE,
  SET_EXPANDED,
  SET_PERIODTYPE  
} from './constants';


export function changePage(value) {
  return {
    type: CHANGE_PAGE,
    value,
  };
}
export function changePageSize(value) {
  return {
    type: CHANGE_PAGESIZE,
    value,
  };
}
export function changeMore(value) {
  return {
    type: CHANGE_MORE,
    value,
  };
}
export function changeUsername(name) {
  return {
    type: CHANGE_USERNAME,
    name,
  };
}
export function toListView(name) {
  return {
    type: TO_LIST,
    name,
  };
}

export function toMasonryView(name) {
  return {
    type: TO_MASONRY,
    name,
  };
}

export function setExpanded(value) {
  return {
    type: SET_EXPANDED,
    value,
  };
}

export function setPeriodType(value) {
  return {
    type: SET_PERIODTYPE,
    value,
  };
}